<template>
<div>
  <v-autocomplete :disabled="empresa.id == 0" multiple v-model="multiUnidades" label="Unidades" :items="unidades" item-text="nome" item-value="id">
    <template v-slot:prepend-item>
      <v-list-item ripple @click="selecionarUnidades">
        <v-list-item-action>
          <v-icon :color="multiUnidades.length > 0 ? 'accent' : ''">{{icon}}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>MARCAR TODOS</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
    <template v-slot:selection="{ item, index }">
      <div v-if="index === 0">
        <span>{{ item.nome }}</span>
      </div>
      <span v-if="index === 1" class="grey--text caption">(+{{ multiUnidades.length - 1 }} outros)</span>
    </template>
  </v-autocomplete>
</div>
</template>

<script>
import service from '../../../services/userservice'
// import {
//   EventBus
// } from './../main'

export default {
  name: 'unidades-select',
  props: {
    mEmpresa: Object
  },
  data () {
    return {
      unidades: [],
      multiUnidades: [],
      unidadesProcessamento: [],
      unidadeProcessamento: {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      },
      unidade: null,
      empresa: { id: 0 }
    }
  },
  watch: {
    multiUnidades (val) {
      this.$emit('multi-unidades', val)
    },
    mEmpresa (val) {
      this.empresa = val
      this.listarUnidades()
    }
  },
  methods: {
    selecionarUnidades () {
      this.$nextTick(() => {
        if (this.multiUnidades.length > 0) {
          this.multiUnidades = []
        } else {
          this.multiUnidades = this.unidades.slice()
        }
      })
    },
    listarUnidades () {
      this.load = true
      let idUnidadeNegocio = 0
      let idEmpresa = 0
      if (this.empresa != null) {
        idEmpresa = this.empresa.id
        idUnidadeNegocio = 0
      } else if (this.unidadeProcessamento != null) {
        idUnidadeNegocio = this.unidadeProcessamento.id
        idEmpresa = this.unidadeProcessamento.idEmpresa
      }
      service.listarUnidades({
        idUnidadeNegocio: idUnidadeNegocio,
        idEmpresa: idEmpresa
      }).then(r => {
        console.log(r.status)
        if (r.status === 200) {
          this.unidades = r.data
        } else if (r.status === 203) {}
      }).finally(() => {
        this.load = false
      })
    }
  },
  mounted () {
  },
  computed: {
    icon () {
      if (this.multiUnidades.length === this.unidades.length) return 'mdi-close-box'
      if (this.multiUnidades.length > 0) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  }
}
</script>
